export default function TS_Syllabus() {
  return (
    <div>
      <h1>TS Syllabus</h1>
      <p>This is the TS Syllabus page.</p>
    </div>
  );
}